angular.module("app").directive("dragToOrder", [
    '$timeout',
    function ($timeout) {
        return {
            restrict: "A",
            scope: {
                originalValue: "=",
                dragToOrder: "=",
                index: "=",
                autoUpdate: "=",
                cb: "&"
            },
            link: function ($scope, element) {
                $scope.init = function () {
                    if ($scope.dragToOrder) {
                        var callback = $scope.cb && $scope.cb();
                        $(element).draggable({
                            containment: "parent",
                            helper: "clone",
                            drag: function (ev, ui) {
                                $("input, select, option").blur();
                                element[0].focus();
                                $(element).data('index', $scope.index)
                            }
                        });
                        $(element).droppable({
                            hoverClass: "will-be-dragged-here",
                            drop: function (ev, ui) {
                                ev.preventDefault();
                                var sourceIndex = +$(ui.draggable).data("index"),
                                    sourceElement = $scope.originalValue[sourceIndex];
                                if (sourceIndex != $scope.index) {
                                    $scope.originalValue.splice(sourceIndex, 1);
                                    $scope.originalValue.splice($scope.index, 0, sourceElement);
                                    $scope.$apply();
                                    callback && callback({autoUpdate: $scope.autoUpdate});
                                }
                            }
                        });
                        $(element).on('dragover', function (e) {
                            e.preventDefault();
                        }, false);
                        $(element).on('dragenter', function (e) {
                            e.preventDefault();
                        }, false);

                        if (!$(element).hasClass('ui-draggable')) {
                            $(element).addClass('ui-draggable');
                        }
                        if (!$(element).hasClass('ui-draggable-handle')) {
                            $(element).addClass('ui-draggable-handle');
                        }
                        if (!$(element).hasClass('ui-droppable')) {
                            $(element).addClass('ui-droppable');
                        }

                        if ($(element).draggable("option", "disabled")) {
                            $(element).draggable("enable")
                        }

                        if ($(element).droppable("option", "disabled")) {
                            $(element).droppable("enable");
                        }
                    } else {
                        if ($(element).hasClass('ui-droppable')) {
                            $(element).droppable("disable");
                        }

                        if ($(element).hasClass('ui-draggable')) {
                            $(element).draggable("disable");
                        }

                        $(element).removeClass('ui-draggable ui-draggable-handle ui-droppable');
                    }
                }

                $scope.$watch('dragToOrder', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        $timeout($scope.init, 0);
                    }
                });

                $scope.init();
            },
        }
    }
]);